import Component from "@ember/component"
import styles from "./lesson-loading.module.css"

export default class LessonLoading extends Component {
  tagName = ""
  readonly styles = styles
}
